// NPM
import React from 'react';

// State
import { useSelector } from 'react-redux';

// Components
import SeatShareGraphRowValue from './SeatShareGraphRowValue';

// Constants
import constants from './constants';

function SeatShareGraphRow(props) {

  // State
  const parties = useSelector(state => state.parties.value);
  const responsiveView = useSelector(state => state.responsiveView.value);

  const party = parties.find(p => p.id === props.seatShareDatum.party);
  const { rowIndex, numRows } = props;
  const { rowHeight, topLabelRowHeight, } = props.dimensions;
  
  // SVG Row calculations and hard coded variables
  const imageWidth = rowHeight - (constants.imagePadding * 2);
  const rowY = (rowHeight * props.rowIndex) + topLabelRowHeight;
  const rowLabelXEnd = imageWidth + (constants.imagePadding * 2) + constants.imageRightMargin;

  return (
    <g transform={ `translate(0, ${ rowY })` }>
      {/* Add the party logo */}
      <image 
        href={ party.image } 
        width={ imageWidth }
        y={ constants.imagePadding }
        x={ constants.imagePadding }
      />

      {/* Add a divider next to the party image */}
      <rect
        x={ rowLabelXEnd }
        y={ 0 }
        width="5"
        height={ rowHeight }
        fill={ party.color }
      />

      {/* Don't show bottom border for last row */}
      {
        rowIndex < numRows - 1 &&
          <rect
            x="0"
            y={ rowHeight - 1 }
            width={ rowLabelXEnd }
            height="1"
            fill="#efefef"
          />
      }

      {/* Create a group for the row value */}
      {/* and transform it along the x-axis to the right of the party image */}
      {/* This will allow all values inside the row to just reference 0,0 */}
      <g transform={ `translate(${ rowLabelXEnd + 2.5 }, 0)` }>
        <SeatShareGraphRowValue
          seatShareDatum={ props.seatShareDatum }
          xDomain={ props.xDomain }
          rowY={ rowY }
          rowHeight={ rowHeight }
          party={ party }
          majoritySeatNum={ props.majoritySeatNum }
          totalSeatNum={ props.totalSeatNum }
        />
      </g>

      {/* Don't show bottom border for last row */}
      {
        rowIndex < numRows - 1 &&
          <rect
            x={ rowLabelXEnd }
            y={ rowHeight - 1 }
            width={ props.xDomain(props.totalSeatNum) }
            height="1"
            fill="#efefef"
          />
      }
    </g>
  )
}

export default SeatShareGraphRow;